import { render, staticRenderFns } from "./HistoricoSolicitacoesAssinatura.vue?vue&type=template&id=65f0d79e"
import script from "./HistoricoSolicitacoesAssinatura.vue?vue&type=script&lang=js"
export * from "./HistoricoSolicitacoesAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports